import { ReactComponent as FlagIcon } from "./svg/si-flag.svg";
import "../flag-icon.scss";

export const SIFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
